angular.module('shared').factory('GTMService', ["$rootScope", function($rootScope) {
  return {
    track: _.debounce(function() {
      var gym, ref, ref1, user;
      if (((ref = window.dataLayer) != null ? ref.push : void 0) && $rootScope.gym) {
        user = window.currentUser;
        gym = $rootScope.gym;
        return window.dataLayer.push({
          "user_signup_date": user.created_at_date,
          "user_email": user.email,
          "user_id": user.id,
          "user_is_account_owner": user.account_owner,
          "user_session_count": user.sign_in_count,
          "buss_name": gym.name,
          "buss_type": gym.business_type,
          "bus_id": gym.id,
          "bus_country": gym.country,
          "bus_timezone": gym.tz,
          "bus_currency": (ref1 = gym.units) != null ? ref1.currency : void 0,
          "bus_subscription_plan": gym.braintree_customer_plan_name,
          "bus_account_status": gym.account_status,
          "bus_monthly_amount": gym.braintree_customer_payment_amount,
          "bus_features_account_has_access_to": gym.features_enabled.join(', '),
          "bus_payment_provider": gym.payment_providers.join(', '),
          "bus_is_credit_card_saved": gym.has_subscription,
          "bus_count_of_users": gym.user_count,
          "bus_number_of_sites": gym.location_count,
          "bus_number_of_membership_plans": gym.membership_plan_count,
          "bus_number_of_members": gym.member_count,
          "bus_number_of_active_members": gym.active_member_count
        });
      }
    }, 100),
    trackPage: function(page, action) {
      if (!window.dataLayer) {
        return;
      }
      return window.dataLayer.push({
        page_name: page,
        action: action
      });
    },
    push: function(data) {
      if (!window.dataLayer) {
        return;
      }
      return window.dataLayer.push(data);
    }
  };
}]);
